import React, {Component} from "react";
// import ModalVideo from 'react-modal-video'
import "./../../node_modules/react-modal-video/scss/modal-video.scss"
import ProgressiveImage from "react-progressive-image-loading";
import { withTranslate } from "react-redux-multilingual";


class About extends Component {


    state = {
        isOpen: false,
    };
    openModal =  () => {
        this.setState({
            isOpen: true
        })
    };
    render() {
        return (
            <section className="ftco-section-2 mb-50" id="about">

                <div className="container ">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="section-2-blocks-wrapper row no-gutters" >

                                {/*
                       <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='tUhcSudL0gM' onClose={() => this.setState({isOpen: false})} />
*/}

                                <div className="img col-sm-12 col-lg-4">
                                    <ProgressiveImage
                                        preview="/images/about-placeholder.png"
                                        src="/images/about_us/2.png"
                                        render={(src, style) => <img alt="about" src={src} style={style}/>}
                                    />
                                    {/* <button onClick={ this.openModal } className="button video-popup" style={{ cursor: 'pointer' }}><span
                               className="ion-ios-play"></span></button>*/}
                                </div>
                                <div className="text col-lg-7 offset-md-1 ftco-animate upper_content">
                                    <div className="text-inner align-self-start">
                                        <h3 className="font-30"> { this.props.translate ("about_header")} </h3>
                                        <p className="font-20"> { this.props.translate ("about_paragragh_1")} </p>
                                    </div>
                                </div>



                            </div>


                            <div className="section-2-blocks-wrapper row no-gutters">

                                {/*
                       <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='tUhcSudL0gM' onClose={() => this.setState({isOpen: false})} />
*/}
                                <div className="text col-lg-7 ftco-animate ">
                                    <div className="text-inner align-self-start">
                                        <h3 className="font-30"> { this.props.translate ("about_header")} </h3>
                                        <p className="font-20">{ this.props.translate ("about_paragragh_2")}</p>
                                    </div>
                                </div>

                                <div className="img col-sm-12 col-lg-4 offset-1 lower_content">
                                    <ProgressiveImage
                                        preview="/images/about-placeholder.png"
                                        src="/images/about_us/1.png"
                                        render={(src, style) => <img alt="about" src={src} style={style}/>}
                                    />
                                    {/* <button onClick={ this.openModal } className="button video-popup" style={{ cursor: 'pointer' }}><span
                               className="ion-ios-play"></span></button>*/}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        )
    }
}


export default withTranslate (About);